export default {"src":"/_next/static/media/requerd.31a2a7c4.svg","height":8,"width":7};